export default {
  letter: {},
  history_letter: {},
  letters: [],
  table_one: [],
  table_two: [],
  periods: [],
  organizations: [],
}
